/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Bell_CreateInputs */

const he_notifications_bell_create = /** @type {(inputs: Notifications_Bell_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`רוצים לקבל התראה כשהמחיר ירד?`)
};

const en_notifications_bell_create = /** @type {(inputs: Notifications_Bell_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to get notified when the price drops?`)
};

/**
* | output |
* | --- |
* | "Want to get notified when the price drops?" |
*
* @param {Notifications_Bell_CreateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_bell_create = /** @type {((inputs?: Notifications_Bell_CreateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Bell_CreateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_bell_create(inputs)
	return en_notifications_bell_create(inputs)
});